import React from 'react';
import ListViewMobile from './mobile';
import ListViewDesktop from './desktop';

const GigListView = (props) => {
    if (props.isMobile) {
        return (<ListViewMobile {...props}/>);
    } else {
        return (<ListViewDesktop {...props}/>);
    }
};

export default GigListView;



// WEBPACK FOOTER //
// ./src/list_view_card/views/index.js